import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "scroll-y grid-con full-a",
  id: "transactions"
}
const _hoisted_2 = { class: "table-filters" }
const _hoisted_3 = { class: "search-filter" }
const _hoisted_4 = { class: "date-filter" }
const _hoisted_5 = { class: "scroll-y" }
const _hoisted_6 = { class: "transaction-container" }
const _hoisted_7 = { class: "inv-data name" }
const _hoisted_8 = { class: "req-val" }
const _hoisted_9 = { class: "inv-data name" }
const _hoisted_10 = { class: "req-val" }
const _hoisted_11 = { class: "inv-data inv-id" }
const _hoisted_12 = { class: "req-val" }
const _hoisted_13 = { class: "inv-data total" }
const _hoisted_14 = { class: "req-val" }
const _hoisted_15 = { class: "inv-data description" }
const _hoisted_16 = { class: "req-val" }
const _hoisted_17 = { class: "inv-data due" }
const _hoisted_18 = { class: "req-val" }
const _hoisted_19 = { class: "inv-data options" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "transaction-options"
}
const _hoisted_22 = { class: "options-container" }
const _hoisted_23 = {
  key: 0,
  class: "transaction-table",
  cellpadding: "0",
  cellspacing: "0",
  border: "0"
}
const _hoisted_24 = {
  key: 1,
  class: "no-transactions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "heading" }, "Invoices and Transactions", -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "g-search",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
          type: "search",
          placeholder: "Search Name"
        }, null, 512), [
          [_vModelText, $setup.searchQuery]
        ])
      ]),
      _createElementVNode("span", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.startDate) = $event)),
          type: "date"
        }, null, 512), [
          [_vModelText, $setup.startDate]
        ]),
        _cache[3] || (_cache[3] = _createTextVNode("-")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.endDate) = $event)),
          type: "date"
        }, null, 512), [
          [_vModelText, $setup.endDate]
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredResults, (invoice) => {
        return (_openBlock(), _createElementBlock("li", {
          key: invoice.invoiceId
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "Customer Name", -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString($setup.userStore.users[invoice.userId]?.name.fullName || "Unknown"), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label" }, "Dog Name", -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString($setup.getDogName(invoice.dogId || "Unknown" )), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "QBO Invoice #", -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString(invoice.qbInvoiceNumber || "Unknown"), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Amount", -1)),
              _createElementVNode("div", _hoisted_14, "$ " + _toDisplayString(invoice.paidAmount) + " / $ " + _toDisplayString(invoice.totalAmount), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "Description", -1)),
              _createElementVNode("div", _hoisted_16, _toDisplayString(invoice.description), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label" }, "Due Date", -1)),
              _createElementVNode("div", _hoisted_18, _toDisplayString(invoice.dueAt ? $setup.moment(invoice.dueAt).format("ddd, MM/DD/YY, h:mm a") : "-"), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: _normalizeClass({open: $setup.invOpenSet.has(invoice.$id)}),
                onClick: ($event: any) => ($setup.invOpenSet.has(invoice.$id) ? $setup.invOpenSet.delete(invoice.$id) : $setup.invOpenSet.add(invoice.$id))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("svg", {
                  class: "icon chevron chevron-down",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    class: "fill",
                    d: "M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z"
                  })
                ], -1)
              ]), 10, _hoisted_20)
            ]),
            ($setup.invOpenSet.has(invoice.$id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "transactions-header" }, "Transactions", -1)),
                  _createElementVNode("div", _hoisted_22, [
                    (invoice.stripePaymentIds?.length)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_23, [
                          _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                            _createElementVNode("th", null, "Amount"),
                            _createElementVNode("th", null, "Initiated"),
                            _createElementVNode("th", null, "Est. Arrival"),
                            _createElementVNode("th")
                          ], -1)),
                          _createVNode($setup["InvoiceTransactions"], {
                            "stripe-ids": invoice.stripePaymentIds || []
                          }, null, 8, ["stripe-ids"])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_24, "No transactions captured for this invoice."))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}